import './TipInfoComponentMobile.scss';

import TIP from '../../../assets/images/MembersArea/amber_mobile.png';

interface tipData {
  message: string | JSX.Element;
}

export const TipInfoComponentMobile = ({ message }: tipData) => {
  return (
    <div className="tip-info-container-mobile">
      <div className="image-box">
        <img onContextMenu={(e) => e.preventDefault()} src={TIP} alt="tip" />
      </div>
      <div className="tip-text">{message}</div>
    </div>
  );
};
